<template>
  <Section 
  background="" 
  :class="[
    content.dark ? '!bg-[#303346] mb-12 mt-4 lg:mb-24 lg:mt-12' : ''
  ]"
  v-if="content.title && content?.item.length">

    <ClientOnly v-if="content?.item.length">
      <swiper
      :slides-per-view="1"
      class="mt-4 md:mt-8 mb-4 md:mb-8"
      >
        <swiper-slide v-for="(item, index) in content?.item">
          <div 
          class="max-w-[1080px] px-4 sm:px-8 mx-auto testimonial"
          :class="[
            content.dark ? 'testimonial--dark' : ''
          ]"
          >
            <div class="testimonial__wrapper mx-auto">
              <div 
              class="testimonial__quote text-2xl md:text-3xl" 
              v-html="item.testimonial_id.quote">
              </div>
              <div class="testimonial__author">
                <div>{{ item.testimonial_id.name }}</div>
                <div>{{ item.testimonial_id.organisation }}</div>
              </div>
            </div>
            <!-- <ImageResponsive
            v-if="item.testimonial_id.image"
            :data="item.testimonial_id.image"
            :xs="4"
            :sm="4"
            :md="4"
            :lg="4"
            :xl="4"
            />
            <div v-else></div> -->
          </div>
        </swiper-slide>
      </swiper>
    </ClientOnly>
  
  </Section>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionIndex: {
    type: Number
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';

.testimonial__quote {
  color: #090d16;
  font-weight: bold;
  line-height: 1.3;
  b, strong, i {
    font-style: normal;
    font-weight: bolder;
    color: #5a6ded;
  }
}

.testimonial__author {
  div:nth-child(1) {
    font-size: 1.125rem;
    color: #8293f8;
    font-weight: bold;
  }
  div:nth-child(2) {
    color: #8293f8;
    margin-top: 8px;
  }
}

.testimonial--dark {
  .testimonial__quote {
    color: $white;
    b, strong, i {
      font-style: normal;
      font-weight: bolder;
      color: #D9DDFC;
    }
  }
  .testimonial__author {
    div:nth-child(1) {
      font-size: 1.125rem;
      color: $white;
    }
    div:nth-child(2) {
      color: #D9DDFC;
      margin-top: 8px;
    }
  }
}

.testimonial-mask {
  z-index: 1;
  white-space: nowrap;
  height: 100%;
  display: block;
  position: relative;
  left: 0;
  right: 0;
  overflow: hidden;
}


.testimonial-slide {
  vertical-align: top;
  white-space: normal;
  text-align: left;
  width: 100%;
  height: 100%;
  display: inline-block;
  position: relative;
}

.testimonial-grid {
  grid-column-gap: 4rem;
  grid-row-gap: 4rem;
  grid-template-rows: auto;
  grid-template-columns: 773fr 18.875rem;
  grid-auto-columns: 1fr;
  display: grid;
}

.testimonial-text-wrapper {
  
}

.testimonial__wrapper {
  grid-column-gap: 1.5rem;
  grid-row-gap: 1.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  max-width: 48.3125rem;
  display: flex;
  grid-area: span 1 / span 1 / span 1 / span 1;
  place-self: center start;
  grid-area: span 1 / span 1 / span 1 / span 1;
  place-self: center start;
}


</style>